import React, { useEffect } from 'react';
import SmppBoxInfo from '../components/SmppBoxInfo';
import CircularProgress from '@mui/material/CircularProgress';
import { AppErrorList } from '../../../shared/components/AppErrorList';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { fetchSmppboxByServerId, fetchSmppboxIfOutdated } from '../../../store/smppbox/smppboxActions';
import {
  selectErrorsForSmppbox
, selectIsLoadingSmppbox
, selectSmppboxByServerId
} from '../../../store/smppbox/smppboxSelector';

interface Props {
  readonly serverId: string;
}

const SmppboxContainer = (props: Props) => {
  const { serverId } = props;
  const dispatch = useAppDispatch();

  const loading = useAppSelector(state => selectIsLoadingSmppbox(state, serverId));
  const smppbox = useAppSelector(state => selectSmppboxByServerId(state, serverId));
  const errors = useAppSelector(state => selectErrorsForSmppbox(state, serverId));

  const handleRefreshStatus = () => {
    dispatch(fetchSmppboxByServerId(serverId));
  };

  useEffect(() => {
    dispatch(fetchSmppboxIfOutdated(serverId));
  }, [dispatch, serverId]);

  if (loading) {
    return <CircularProgress size={20} />;
  }

  if (errors.length > 0) {
    return (<AppErrorList errors={errors} />);
  }

  return (
    <SmppBoxInfo
      data={smppbox?.status}
      onRefreshStatus={handleRefreshStatus}
    />
  );
}

export default SmppboxContainer;
